import { roadmapIllustration } from '~/assets/images'
import { Hero, HeroImage } from '~/tenset-components'

export function HeroRoadmap() {
  return (
    <Hero
      title="Accelerating Our Growth to New Heights"
      description="For many years, we have provided our community with numerous opportunities and helped our business partners create and launch promising products. Now, it's time to shift into high gear and expand our presence in the crypto sector, taking our success to even greater heights."
      rightContent={
        <HeroImage
          src={roadmapIllustration}
          alt="A person on a glowing motorcycle rides towards a neon sunset on a colorful road."
        />
      }
    />
  )
}
